import styled from 'styled-components';
import Button from 'antd/lib/button';

export const StyledButton = styled(Button)`
  position: absolute;
  right: 170px;
  top: 10px;
`;
